<template>
  <div class="container mb-5">
    <legend>Таблица расходов</legend>
    <div class="row">
      <div class="col col-auto" style="max-width: 300px;">
        <date-picker :first-day-of-week="1" :format="momentFormat"
                     :input-attr="{required:true}"
                     class="w-100"
                     lang="ru"
                     v-model="from" valueType="format"></date-picker>
      </div>
      <div class="col col-auto" style="max-width: 300px;">
        <date-picker :first-day-of-week="1" :format="momentFormat"
                     :input-attr="{required:true}"
                     class="w-100"
                     lang="ru"
                     v-model="to" valueType="format"></date-picker>
      </div>
    </div>
    <table class="table table-bordered table-sm mt-5" v-if="ExpensesFormatted">
      <tbody>
      <template v-for="(ExpenseGroup, ExpenseGroupId) in ExpensesFormatted">
        <tr>
          <td class="font-weight-bold" colspan="2">{{ExpenseGroups[ExpenseGroupId].Name}}</td>
        </tr>

        <template v-for="(Expense, index) in ExpenseGroup">
          <tr>
            <td class="pl-3">{{ExpenseTypes[Expense.ExpenseTypeId].Name}}</td>
            <td class="pl-3">{{Expense.Summary}}</td>
          </tr>
        </template>
      </template>

      <tr>
        <td class="font-weight-bold">Итого</td>
        <td class="font-weight-bold">{{TotalSummary}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { get, post } from '@/admin/services/api/http-utils';

const date = new Date();
const to = moment(date)
  .format('DD-MM-YYYY');
date.setDate(date.getDate() - 7);
const from = moment(date)
  .format('DD-MM-YYYY');

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      from,
      to,
      momentFormat: {
        // Date to String
        stringify: date => (date ? moment(date)
          .format('DD-MM-YYYY') : ''),
        // String to Date
        parse: value => (value ? moment(value, 'DD-MM-YYYY')
          .toDate() : null),
      },
      Expenses: [],
      ExpenseTypes: [],
      ExpenseGroups: [],
    };
  },
  watch: {
    from() {
      this.fetchExpenseReport();
    },
    to() {
      this.fetchExpenseReport();
    },
    // Expenses() {
    //   if (this.Expenses.length) {
    //     this.ExpensesFormatted = _.groupBy(this.Expenses, 'ExpenseGroupId');
    //   }
    // },

  },
  computed: {
    ExpensesFormatted() {
      if (this.Expenses.length) {
        return _.groupBy(this.Expenses, 'ExpenseGroupId');
      }
      return null;
    },
    TotalSummary() {
      if (this.Expenses.length) {
        return _.sumBy(this.Expenses, (o) => {
          return parseInt(o.Summary ? o.Summary : 0);
        });
      } else {
        return 0;
      }
    },
  },
  async mounted() {
    await this.fetchExpenseReport();
  },
  methods: {
    async fetchExpenseReport() {
      if (!(this.from && this.to)) {
        return;
      }
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/flow/expense-table/${this.from}/${this.to}`);
      this.Expenses = data.Expenses;
      this.ExpenseTypes = data.ExpenseTypes;
      this.ExpenseGroups = data.ExpenseGroups;
      console.log(data);
    },
  },
};

</script>
